export enum ConversationTypeEnum {

    INBOUND = 'INBOUND',
    OUTBOUND = 'OUTBOUND'

}